import styled, { css } from 'styled-components';
import { Field as BaseField, FieldProps } from '../../base/Field';

export const FieldMinWidth = 100;

export const Field = styled(BaseField)<
  FieldProps & {
    isOverflowing?: boolean;
  }
>`
  ${({ autoSize }) =>
    !autoSize &&
    css`
      position: relative;
      overflow: hidden;
      justify-content: flex-start;

      input {
        min-width: 0;
      }
    `}
`;

export const PillsWrapper = styled(BaseField)`
  position: absolute;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  left: 0;
  right: 0;
  overflow: hidden;
`;
